import React from 'react';
import { Button, InputGroup } from 'react-bootstrap';
import { CSVLink } from 'react-csv';
import { blue } from '../../../utils/constants';

export const exportCSV = function ( data, headers, filename ) {
    return  <InputGroup>
              <InputGroup.Button>
                {
                  ( data.length > 0 ) 
                    && (  <Button style={{ color:blue }}>
                              <CSVLink 
                                  data={ data } 
                                  headers={ headers }
                                  filename= { filename }
                                  target='_blank' 
                                  style={{ color:'blue' }} >
                                  <i className="fa fa-file-excel-o" aria-hidden="true"  />&nbsp;&nbsp;<span >Export ( .csv )</span>
                              </CSVLink>
                          </Button>
                        )
                }
              </InputGroup.Button>                              
            </InputGroup>
}

export const tableOptions =   {
  page: 1,  // which page you want to show as default
  sizePerPageList: [ {
    text: '10', value: 10
  }, {
    text: '25', value: 25
  }, {
    text: '50', value: 50
  } ], // you can change the dropdown list for size per page
  sizePerPage: 25,  // which size per page you want to locate as default
  pageStartIndex: 1, // where to start counting the pages
  paginationSize: 3  // the pagination bar size.
};

export const getNum = function(val) {
  if (isNaN(val)) {
    return 0;
  }
  return val;
}


// WEBPACK FOOTER //
// ./src/components/pages/common/index.js